import { LinearGradient } from "expo-linear-gradient";
import { VStack } from "native-base";
import React from "react";
import { createShimmerPlaceholder } from "react-native-shimmer-placeholder";
import styled from "styled-components/native";

const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

const NotificationsLoading = () => {
  const data = new Array(10).fill(null);
  return (
    <VStack>
      {data.map((i) => (
        <VStack m="2" p="2" bgColor="white.50" shadow="4" rounded="md" space="2">
          <Loader height={80} />
        </VStack>
      ))}
    </VStack>
  );
};

const Loader = styled(ShimmerPlaceholder)`
  width: ${({ width }) => (width ? width + "px" : "100%")};
  height: ${({ height }) => (height ? height + "px" : "100%")};
`;

export default NotificationsLoading;
